import React, { FC }                      from 'react';
import { formatOption }                   from '../../../../util';
import { SelectField, SelectFieldProps }  from '../../../components/forms';
import { INPUT_TYPE_LABELS, INPUT_TYPES } from '../../../../constants/FormEnums';
import { PreSelectedSelectField }         from '../../../../types';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( INPUT_TYPES.SHORT_TEXT, INPUT_TYPE_LABELS.SHORT_TEXT ),
		formatOption( INPUT_TYPES.LONG_TEXT, INPUT_TYPE_LABELS.LONG_TEXT ),
		formatOption( INPUT_TYPES.CHECKBOX, INPUT_TYPE_LABELS.CHECKBOX ),
		formatOption( INPUT_TYPES.SELECT, INPUT_TYPE_LABELS.SELECT ),
		formatOption( INPUT_TYPES.SELECT_MULTI, INPUT_TYPE_LABELS.SELECT_MULTI ),
		formatOption( INPUT_TYPES.DATE, INPUT_TYPE_LABELS.DATE ),
		formatOption( INPUT_TYPES.DATE_RANGE, INPUT_TYPE_LABELS.DATE_RANGE ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as InputTypeDropdown };
